import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogTitle,
  IconButton,
  Slide,
  useMediaQuery,
  useTheme,
  Typography
} from '@mui/material';

// Smooth slide-up transition
const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const FMSModal = ({
  children,
  onClose,
  maxWidth = 'sm',
  fullWidth = true,
  ...rest
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      {...rest}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : 3, // Modern rounded corners (12px)
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          backgroundColor: '#FFFFFF',
          backgroundImage: 'none',
          overflow: 'hidden', // Ensures children respect border radius
          p: 0, // Removed padding so header/footer are flush
          maxHeight: fullScreen ? '100vh' : '90vh'
        }
      }}
      onClose={(e, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        if (onClose) onClose();
      }}
    >
      {children}
    </Dialog>
  );
};

FMSModal.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  fullWidth: PropTypes.bool
};

export default FMSModal;

export const FMSModalTitle = ({ title, onCancel, sx }) => {
  const theme = useTheme();

  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF', // Clean White
        borderBottom: `1px solid ${theme.palette.divider}`,
        ...sx
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 700, color: '#111827' }}>
        {title}
      </Typography>
      {onCancel ? (
        <IconButton
          aria-label="close"
          onClick={onCancel}
          size="small"
          sx={{
            color: theme.palette.text.secondary,
            transition: 'all 0.2s',
            '&:hover': {
              color: theme.palette.error.main,
              backgroundColor: theme.palette.action.hover,
              transform: 'rotate(90deg)'
            }
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

FMSModalTitle.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  sx: PropTypes.object
};
